import { Quantity } from '@elderbyte/ngx-starter'
import { Property } from '../../../../properties/property'

export class ItemSortSpec {
  public properties: ItemSortProperty[] = []
}

export class ItemSortProperty {
  public id: string

  public propertyId: string

  /**
   * Has to be populated!
   */
  public property: Property

  public sortOrder: SortOrder = SortOrder.ASCENDING

  public tolerance: Quantity
}

export enum SortOrder {
  ASCENDING = 'ASCENDING',

  DESCENDING = 'DESCENDING',
}
